import { useHistory } from "react-router";
import { BtnContainer, BtnLogueo, ContainerLogueo } from "./localStyle";
import { useContext } from "react";
import { PortalContext } from "_+_Portal/context/Provider";
import { setFlgBeneficios } from "_+_Portal/context/Actions/beneficios/beneficios";

const ModalLogueo = ({ dissmiss }) => {
  const { beneficiosState, beneficiosDispatch } = useContext(PortalContext);
  const history = useHistory();

  const irAlLogueo = () => {
    dissmiss();
    history.push("/");
    setFlgBeneficios(true)(beneficiosDispatch);
  };

  return (
    <ContainerLogueo>
      <p className="rb18l">Para poder asociarte primero tenés que loguearte</p>
      <BtnContainer>
        <BtnLogueo className={`rb16l bgc-primary c-white`} onClick={irAlLogueo}>
          Loguearse
        </BtnLogueo>
        <BtnLogueo className={`rb16l bgc-latex30 c-white`} onClick={dissmiss}>
          Cerrar
        </BtnLogueo>
      </BtnContainer>
    </ContainerLogueo>
  );
};

export default ModalLogueo;
